"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VizyonVeTemsil() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const practiceAreas = [{
    id: 1,
    title: "Ceza Hukuku"
  }, {
    id: 2,
    title: "Gayrimenkul Hukuku"
  }, {
    id: 3,
    title: "Ticaret Hukuku"
  }, {
    id: 4,
    title: "Aile Hukuku"
  }, {
    id: 5,
    title: "Miras Hukuku"
  }, {
    id: 6,
    title: "Sigorta Hukuku"
  }, {
    id: 7,
    title: "İcra Hukuku"
  }, {
    id: 8,
    title: "Sözleşmeler Hukuku"
  }, {
    id: 9,
    title: "Kira Hukuku"
  }, {
    id: 10,
    title: "Tazminat Hukuku"
  }, {
    id: 11,
    title: "Ticari Uyuşmazlıklar"
  }, {
    id: 12,
    title: "Kurumsal Savunma"
  }];
  return <section data-section-id="3626" id="vizyon-ve-temsil" className="relative min-h-screen w-full overflow-hidden bg-background py-16 sm:py-32 lg:py-48 border-b border-border">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695387/img/istanbul_modern_office_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695387/img/istanbul_modern_office_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695387/img/istanbul_modern_office_architecture.png-wvc-sizes" alt="Istanbul Modern Architecture" className="h-full w-full object-cover opacity-15 grayscale contrast-125" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-primary/60" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1600px] px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
          
          {}
          <div ref={contentRef} className={`lg:col-span-9 flex flex-col justify-center lg:justify-start min-h-screen lg:min-h-auto transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="font-serif text-[clamp(2.375rem,5vw,4.625rem)] font-medium leading-[1.05] tracking-[-0.3px] text-[#F3EFE7] max-w-[850px] text-left">
              Ceza Hukuku, Kentsel Dönüşüm<br className="hidden sm:inline" /> ve Ticari Uyuşmazlıklar
            </h1>

            <p className="mt-6 font-serif italic text-[clamp(1.375rem,3.5vw,2.375rem)] text-[#D4AF8D] leading-[1.2] max-w-[850px] text-left">
              Dosyaya Özgü Hukuki Değerlendirme ve Temsil
            </p>

            <div className="mt-16 flex gap-12">
              {}
              <div className="hidden w-[1px] bg-border relative lg:block">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-primary" />
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-primary" />
              </div>
              
              <div className="max-w-2xl space-y-8">
                <p className="text-lg md:text-xl text-gray-100/90 leading-[1.65] max-w-[650px]">
                  Ceza soruşturmaları, gözaltı ve tutuklama süreçleri, kentsel dönüşüm, müteahhit uyuşmazlıkları, ticari alacaklar, icra, tazminat ve gayrimenkul davalarında Bakırköy'deki ofisimizden hukuki danışmanlık ve dava takibi.
                </p>
              </div>
            </div>
          </div>

          {}
          <div className="hidden lg:col-span-3 lg:flex flex-col justify-end border-l border-border/60 pl-12 pb-12 relative">
            {}
            <div className="absolute top-0 left-[-3px] w-1.5 h-1.5 bg-primary" />
            
            <div className="space-y-20">
              <div className="space-y-4">
                <p className="font-sans text-[10px] font-bold uppercase tracking-[0.35em] text-[#D9D9D9]">Lokasyon</p>
                <p className="font-sans text-sm font-medium text-white tracking-tight">İstanbul, TR</p>
              </div>
              <div className="space-y-4">
                <p className="font-sans text-[10px] font-bold uppercase tracking-[0.35em] text-[#D9D9D9]">Uzmanlık</p>
                <div className="flex flex-col gap-2.5">
                  {practiceAreas.map((area, i) => <p key={area.id} data-index={i} className="font-sans text-sm font-medium text-white tracking-tight">
                      {area.title}
                    </p>)}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-border">
        <div className="absolute left-0 top-[-3px] w-1.5 h-1.5 bg-primary" />
        <div className="absolute right-0 top-[-3px] w-1.5 h-1.5 bg-primary" />
      </div>
    </section>;
}